import { Modal } from "@general-backoffice/core/index";
import React from "react";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";

import useModal from "../hooks/useModal";

const videos: Record<string, string> = {
  en: "https://youtu.be/_q5Aa_EQKnw",
  es: "https://youtu.be/GGUU4JSB5kA",
};

interface DistributorWelcomeModalProps {
  autoOpen?: boolean;
  isOpen: boolean;
  close: () => void;
}

export const useDistributorWelcomeModal = ({ autoOpen }: { autoOpen?: boolean }) =>
  useModal({ Modal: DistributorWelcomeModal, autoOpen });

const DistributorWelcomeModal = ({ isOpen, close }: DistributorWelcomeModalProps) => {
  const { t, i18n } = useTranslation("modals", { keyPrefix: "distributorWelcome" });

  const videoUrl = videos[i18n.language] || videos.en;

  return (
    <Modal.Simple title={t("title")} isOpen={isOpen} closeText={t("closeButton")} toggleOpen={close} size="md">
      <div className="flex-center my--4 mx--4 overflow-hidden">
        <ReactPlayer url={videoUrl} controls volume={1} />
      </div>

      {/*<div className="bg-warning p-3">*/}
      {/*  <Trans*/}
      {/*    t={t} i18nKey="warning"*/}
      {/*    components={[<div style={{ fontWeight: 600 }}/>, <small/>]}*/}
      {/*  />*/}
      {/*</div>*/}
    </Modal.Simple>
  );
};

export default DistributorWelcomeModal;
